import Button from "@/shared/form/button";
import { useLocalizedControl } from "../../model/localized-value-control-context";
import { GlobalOutlined } from "@ant-design/icons";
import Form from "@/shared/form/form";

export function OpenFullLocalizationButton() {
  const {
    open,
    formItemProps: { name },
    languages,
    languageToControlName,
  } = useLocalizedControl();
  const form = Form.useFormInstance();

  const localizedFields = languages.map((locale) =>
    [name, languageToControlName(locale)].join("/"),
  );

  const hasErrors = form
    .getFieldsError()
    .filter((field) => localizedFields.includes(field.name.join("/")))
    .reduce((result, field) => result || field.errors.length > 0, false);

  return (
    <Button
      icon={<GlobalOutlined />}
      onClick={open}
      type="primary"
      danger={hasErrors}
      data-testid="localized-value-open-translations-button"
    />
  );
}
